import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import plugins from './plugins' // eslint-disable-line no-unused-vars

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
